import { walk } from '../utils';
export function matches(html) {
  return /docs-internal-guid/.test(html);
}
export function clean(root) {
  root = unwrapBTag(root);
  stripExtraBreaks(root);
  return root;
}

// Google docs wraps everything in a `B` tag, which makes life a bit hard for the parser
function unwrapBTag(root) {
  let wrappingBTag = root.querySelector('b');
  if (wrappingBTag) {
    return wrappingBTag;
  }
  return root;
}
function stripExtraBreaks(root) {
  let nodesToSkip = ['UL', 'OL'];
  walk(root, nodesToSkip, node => {
    if (node.nodeName === 'BR') {
      node.parentNode?.replaceChild(document.createElement('p'), node);
    }
  });
}